export const environment = {
  production: true,
  counterServiceUrl: "https://gateway.zafer.net"
};
